// URLs constants
const UNIQUE_CODE="iocvyb5prk"
const STAGE="production";
const API_BASE_URL=`https://${UNIQUE_CODE}.execute-api.us-east-2.amazonaws.com/${STAGE}`;

export const GET_INSTANCES_URL=`${API_BASE_URL}/instances`;
export const ACTION_URL=`${API_BASE_URL}/action`;